module.exports = __webpack_public_path__ + "static/img/fluent-music-note-1-24-regular.40b24b06.svg";